import { Formik } from 'formik';
import * as Yup from 'yup';
import Input from '../../../components/form-control/Input';
import SelectDropdown from '../../../components/form-control/SelectDropdown';
import { REPAIR_TYPES } from '../../../resources/enums';
import {
  getSelectOptionsFromEnum
} from '../../../utils/miscFunctions';
import Button from '../../../components/form-control/Button';
import { 
  createNewRNPL,
  getAllCustomersList,
  getCustomerVehicules, 
} from '../../../api/requests';
import { 
  ICreateRNPLDTO 
} from '../../../resources/interfaces'; 
import TextArea from '../../../components/form-control/TextArea';
import { useState } from 'react';
import { Customer } from '../../../models/customer/Customer'; 
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getSelectedCountry } from '../../../states/slices/resourceSlice';

interface IRNPLProps { 
  onClose: () => void;
  onProceed: () => void;
}

interface IFormData {
  customerId: number;
  vehicleId:number;
  repairType: string;
  otherRepairType: string;
  repairDescription: string;
  repairCost: number;
  ownerConsent: boolean;
} 


const AddNewRnPl = (props: IRNPLProps): JSX.Element => {
  const [submitting, setSubmitting] = useState<boolean>(false); 
  const [applicants, setApplicants] = useState<any>([]);
  const [applicantVehicleList, setApplicantVehicleList] = useState<any>([]);
  const [vehicleCardNumber, setVehicleCardNumber] = useState<string>("");
  const selectedCountry = useSelector(getSelectedCountry);
  const countryId = selectedCountry?.id ?? 1

  const getAllApplicants = async () => {
 
    try {
      const response = await getAllCustomersList();
      const _customers = response?.data?.content?.map((customer: any) => {
         return new Customer(customer); 
      });
      
      setApplicants(response?.data?.data);
   
    } catch (error) {
    }  
  };
 
  const getAllCustomerVehicules = async(id:string)=>{
    const response = await getCustomerVehicules(id)
    .then((response)=>{
      
      setApplicantVehicleList(response?.data?.data)
    })
    .catch((error)=>{
      console.log(error)
    })

    return response;
    
  }
   
const selectApplicantInfos = (value: string): Customer => {
  const applicant = applicants?.find((applicant: any) => value == applicant.id); 
  return applicant ;  
}

const selectedVehicleInfos = (value: string): Customer => {
  const applicant = applicantVehicleList?.find((applicant: any) => value == applicant.id); 
  return applicant ;  
}
 
useQuery({queryKey:['getAllApplicants'], queryFn:getAllApplicants})
const yesOrno = [{name:'YES', value:true}, {name:'NO', value:false}]
  return (
    <div className="py-6 px-3 md:px-6  w-full">
      <Formik
        initialValues={{
          customerId: 0,
          vehicleId: 0,
          repairType: '',
          otherRepairType: '',
          repairDescription: '',
          repairCost: 0,
          ownerConsent: false
        }}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={Yup.object().shape({
          repairDescription: Yup.string().trim().required('Description is required.'),
          repairCost: Yup.number()
            .required('Repair Cost is required.')
            .positive('Repair Cost must be a positive number.')
            .max(5000, 'Repair Cost must be less than or equal to 5000.'),
          ownerConsent:  Yup.boolean().oneOf([true], "Owner's consent is required.").required("Owner's consent is required.")
        })}
       
        onSubmit={async (values: IFormData, { resetForm }) => {
          const payload: ICreateRNPLDTO = {
            countryId: countryId,
            customerId: values.customerId,
            vehicleId: values.vehicleId,
            repairType: values.repairType == 'OTHER' ? values.otherRepairType : values.repairType,
            repairDescription: values.repairDescription,
            repairCost: values.repairCost,
            ownerConsent: values.ownerConsent 
          };

         await createNewRNPL(payload)
            .then((response) => {
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              resetForm();
              props.onProceed();
            });
        }}>
        {({
          values,
          errors,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="" onSubmit={handleSubmit}>
            <div className="w-full flex flex-col space-y-8">
              <SelectDropdown
                name="customerId"
                listSelectedValue={values.customerId}
                onChange={(value: string) => {
                  setFieldValue('customerId', value);
                  getAllCustomerVehicules(value);
                  setApplicantVehicleList([]);
                }}
                label="Applicant"
                placeholder="Select applicant"
                list={applicants?.map((applicant: any) => ({
                  id: `${applicant.id}`,
                  name: `${applicant.firstName} ${applicant.lastName}`,
                  value: `${applicant.id}`
                }))}
                required
                error={touched.customerId ? errors.customerId : undefined}
                helperText={touched?.customerId ? errors.customerId : undefined}
                selectInputClassName="rounded"
                search
              />
              <SelectDropdown
                name="vehicleId"
                listSelectedValue={values.vehicleId}
                onChange={(value: string) => {
                  setFieldValue('vehicleId', value);
                  const slicedValue = value.split(' - ');
                  setVehicleCardNumber(slicedValue[0]);
                }}
                label="Applicant Vehicle(s)"
                placeholder="Select applicant vehicle(s)"
                list={applicantVehicleList?.map((vehicle: any) => ({
                  name: `${vehicle.registrationNumber} - ${vehicle.model} ${vehicle.registrationYear}`,
                  value: `${vehicle.id}`
                }))}
                required
                error={touched.vehicleId ? errors.vehicleId : undefined}
                helperText={touched?.vehicleId ? errors.vehicleId : undefined}
                selectInputClassName="rounded"
              />


              <div className={` ${values.repairType == 'OTHER' && 'rounded border flex flex-col space-y-8 p-3 border-gray-300'}`}>
                <SelectDropdown
                  name=""
                  listSelectedValue={values.repairType}
                  onChange={(value: string) => {
                    setFieldValue('repairType', value);
                  }}
                  label="Repair Type"
                  placeholder="Select repair type"
                  list={getSelectOptionsFromEnum(REPAIR_TYPES)}
                  required
                  error={touched.repairType ? errors.repairType : undefined}
                  helperText={touched?.repairType ? errors.repairType : undefined}
                  selectInputClassName="rounded"
                />

                <TextArea
                  name="otherRepairType"
                  value={values.otherRepairType}
                  onChange={handleChange}
                  onBlur={handleChange} 
                  placeholder="Provide any other type..."
                  required
                  error={touched.otherRepairType ? errors.otherRepairType : undefined}
                  helperText={touched?.otherRepairType ? errors.otherRepairType : undefined}
                  classes={`rounded ${values.repairType !== 'OTHER' && 'hidden'}`}
                
                />
              </div>
              <TextArea
                name="repairDescription"
                value={values.repairDescription}
                onChange={handleChange}
                onBlur={handleChange}
                label="Repair Description"
                placeholder="Provide description..."
                required
                error={touched.repairDescription ? errors.repairDescription : undefined}
                helperText={touched?.repairDescription ? errors.repairDescription : undefined}
                classes="rounded"
              />

              <Input
                type={'number'}
                name="repairCost"
                value={values.repairCost}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Repair Cost"
                placeholder="Enter repair cost"
                required
                error={touched.repairCost ? errors.repairCost : undefined}
                helperText={touched?.repairCost ? errors.repairCost : undefined}
                className="rounded"
              />
              <SelectDropdown
                name="ownerConsent"
                listSelectedValue={values.ownerConsent}
                onChange={(value: boolean) => {
                  setFieldValue('ownerConsent', value);
                }}
                label="Does Owner Consent To RNPL?"
                placeholder="Yes or No"
                list= {yesOrno?.map((val: any) => ({
                  id: `${val.id}`,
                  name: `${val.name}`,
                  value: `${val.value}`
                }))} 
                // list= {[{name:'YES', value:true}, {name:'NO', value:false}]} 
             
                required
                error={touched.ownerConsent ? errors.ownerConsent : undefined}
                helperText={touched?.ownerConsent ? errors.ownerConsent : undefined}
                selectInputClassName="rounded"
              />
              <div className="flex-col-reverse justify-end w-full gap-5 flex md:flex-row  mt-10 ">
                <div className="">
                  <Button
                    label="Cancel"
                    onClick={props.onClose}
                    curved
                    className="w-fit px-4 rounded-full border border-primary-border bg-gray-100 hover:bg-gray-200 "
                  />
                </div>

                <div className="">
                  <Button
                    label="Save"
                    className="w-fit px-4 rounded-full border border-primary-border bg-primary-main  hover:bg-primary-main "
                    onClick={handleSubmit}
                    curved
                    bgColor="primary"
                    loading={submitting}
                    disabled={submitting}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default AddNewRnPl;
